/**
 * Glossary — słownik skrótów branżowych MASKIL (2026-05-26).
 *
 * Powód: zgłoszenie Izabeli 0475d485 — "zastosowane jakieś tajemnicze skróty
 * działań, nie wiadomo co oznaczają". Każdy skrót dostaje tooltip na hover.
 *
 * Użycie:
 *   <TermTooltip term="SWZ">SWZ</TermTooltip>
 * albo programowo:
 *   import { lookupTerm } from 'lib/glossary';
 *   const def = lookupTerm('SWZ');
 */

export const GLOSSARY = {
  // Zamówienia publiczne (PZP)
  SWZ: {
    full: 'Specyfikacja Warunków Zamówienia',
    desc: 'Dokument zawierający wymagania zamawiającego: opis przedmiotu zamówienia, warunki udziału, kryteria oceny ofert, terminy, wadium. Kluczowy dla startu w przetargu.',
  },
  PZP: {
    full: 'Prawo Zamówień Publicznych',
    desc: 'Ustawa regulująca udzielanie zamówień publicznych w Polsce (Dz.U. 2019 poz. 2019, z późn. zm.).',
  },
  JEDZ: {
    full: 'Jednolity Europejski Dokument Zamówienia',
    desc: 'Standardowy formularz UE potwierdzający spełnianie warunków udziału w przetargu. Wypełniany w formacie XML/PDF zamiast wszystkich zaświadczeń.',
  },
  CPV: {
    full: 'Common Procurement Vocabulary',
    desc: 'Wspólny słownik zamówień UE — kodowanie typu robót/usług (np. 31500000 = urządzenia oświetleniowe). Klucz do matchowania ogłoszeń z naszym profilem.',
  },
  BZP: {
    full: 'Biuletyn Zamówień Publicznych',
    desc: 'Polski rejestr ogłoszeń o zamówieniach publicznych (ezamowienia.gov.pl) — źródło Pipeline A.',
  },
  TED: {
    full: 'Tenders Electronic Daily',
    desc: 'Dziennik Urzędowy UE Suplement (ted.europa.eu) — ogłoszenia o zamówieniach o wartości UE.',
  },
  PIN: {
    full: 'Prior Information Notice',
    desc: 'Wstępne ogłoszenie informacyjne na TED — zamawiający zapowiada że w ciągu 12 miesięcy ogłosi przetarg. Najsilniejszy publiczny sygnał pre-tender.',
  },

  // Profit Room / RFQ
  RFQ: {
    full: 'Request for Quotation',
    desc: 'Zapytanie ofertowe — wysyłamy do producentów/dostawców (np. opraw LED) aby uzyskać ceny i terminy. **MASKIL wykorzystuje to z perspektywy sprzedawcy** który kompletuje ofertę dla zamawiającego, nie z perspektywy kupującego.',
  },
  BoQ: {
    full: 'Bill of Quantities',
    desc: 'Przedmiar robót — lista materiałów i ilości wyciągnięta z SWZ (np. 1200 opraw LED 60W z DALI 2.0). Podstawa do RFQ i kalkulacji ofertowej.',
  },

  // Inwestycje (Pipeline B)
  GUNB: {
    full: 'Główny Urząd Nadzoru Budowlanego',
    desc: 'Centralny rejestr pozwoleń budowlanych w Polsce. Źródło Pipeline B — żywe inwestycje 6-18 miesięcy przed przetargiem.',
  },
  WPF: {
    full: 'Wieloletnia Prognoza Finansowa',
    desc: 'Plan budżetowy JST (gminy/powiatu/województwa) na 3-5 lat. Pokazuje planowane wydatki inwestycyjne — wczesny sygnał inwestycji.',
  },
  'DŚU': {
    full: 'Decyzja o Środowiskowych Uwarunkowaniach',
    desc: 'Wydawana przez RDOŚ/GDOŚ dla dużych projektów (>2 ha, przemysł, infrastruktura). Wymagana 6-18 miesięcy PRZED pozwoleniem budowlanym — najwcześniejszy publiczny sygnał dla dużych inwestycji.',
  },
  RDOŚ: {
    full: 'Regionalna Dyrekcja Ochrony Środowiska',
    desc: '16 regionalnych dyrekcji wydających decyzje środowiskowe pierwszej instancji.',
  },
  GDOŚ: {
    full: 'Generalna Dyrekcja Ochrony Środowiska',
    desc: 'Centralny organ — decyzje odwoławcze nadzwyczajne (duże, kontrowersyjne projekty: autostrady, elektrownie, hale).',
  },

  // Intel
  SPHINX: {
    full: 'SPHINX intel',
    desc: 'System wywiadu MASKIL — łączy KRS, CEIDG, sanctions, shell company score, B6 multi-LLM consensus. Wzbogaca dane o firmach (zarząd, sytuacja finansowa).',
  },
  KRS: {
    full: 'Krajowy Rejestr Sądowy',
    desc: 'Publiczny rejestr przedsiębiorców, fundacji, stowarzyszeń. Źródło danych o zarządzie, kapitale, statusie firmy.',
  },
  CEIDG: {
    full: 'Centralna Ewidencja i Informacja o Działalności Gospodarczej',
    desc: 'Rejestr osób prowadzących jednoosobową działalność gospodarczą.',
  },
  BIP: {
    full: 'Biuletyn Informacji Publicznej',
    desc: 'Publiczny portal jednostek administracji (gmin/powiatów/spółek skarbu państwa) z dokumentami i danymi kontaktowymi.',
  },

  // Oświetlenie / techniczne LED
  LED: {
    full: 'Light Emitting Diode',
    desc: 'Dioda elektroluminescencyjna — branża MASKIL beta. Specs: moc [W], strumień [lm], barwa [K], skuteczność [lm/W].',
  },
  DALI: {
    full: 'Digital Addressable Lighting Interface',
    desc: 'Standard cyfrowego sterowania oświetleniem (IEC 62386). DALI-2 = nowsza wersja z rozszerzonymi funkcjami sensorów i scen.',
  },
  DIALux: {
    full: 'DIALux',
    desc: 'Oprogramowanie do projektowania oświetlenia — symulacje, obliczenia natężenia, rendery. Standard projektantów oświetlenia.',
  },
  UGR: {
    full: 'Unified Glare Rating',
    desc: 'Wskaźnik olśnienia. UGR<19 = biuro, UGR<22 = hala sportowa treningowa, UGR<16 = precyzyjne stanowisko.',
  },
  IP: {
    full: 'Ingress Protection rating',
    desc: 'Stopień ochrony obudowy (IP65 = pyłoszczelna + strugi wody). PN-EN 60529.',
  },
};

/** lookup — case-insensitive. Zwraca `{full, desc}` albo null. */
export function lookupTerm(term) {
  if (!term) return null;
  const key = String(term).trim();
  if (GLOSSARY[key]) return GLOSSARY[key];
  // Try case-insensitive match
  const upper = key.toUpperCase();
  for (const k of Object.keys(GLOSSARY)) {
    if (k.toUpperCase() === upper) return GLOSSARY[k];
  }
  return null;
}

/** Wszystkie terminy (do strony Glossary jeśli kiedyś będzie) */
export function allTerms() {
  return Object.entries(GLOSSARY).map(([term, def]) => ({ term, ...def }));
}
